import { gql } from '@grandvisionhq/graphql';

const redirectPaymentResponse = gql`
  fragment RedirectPaymentResponseFragment on PlaceOrderMutationRedirectPaymentResponse {
    redirectUrl
    resultType
    httpMethod
  }
`;

export { redirectPaymentResponse };
//# sourceMappingURL=redirect-payment-response.js.map
